import { Popup } from "../popup/popup";
import { Input } from "../input/input";
import { Button } from "../button/button";
import { Text } from "../text/text";

import styles from "./textEditor.module.css";

export const LinkPopup = ({
    title,
    description,
    active,
    setActive,
    linkUrl,
    setLinkUrl,
    onCancel,
    onApply,
}) => {
    return (
        <Popup
            active={active}
            setActive={(nextActive) => {
                if (!nextActive) {
                    onCancel();
                    return;
                }

                setActive(true);
            }}
        >
            <div className={styles.link_popup_header}>
                <Text as="div" variant="h1" className={styles.link_popup_title} align="center">{title}</Text>
                <Text as="div" variant="body" className={styles.link_popup_subtitle} align="center">{description}</Text>
            </div>

            <Input
                type="text"
                value={linkUrl}
                setValue={setLinkUrl}
                placeholder="https://example.com"
                autoFocus
            />

            <div className={styles.link_popup_buttons}>
                <Button text="Отменить" type="hint" onClick={onCancel} />
                <Button
                    text="Применить"
                    type="primary"
                    onClick={onApply}
                    disabled={!linkUrl.trim()}
                />
            </div>
        </Popup>
    );
};
